import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScSearchFallbackScenario = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;

  & > .text {
    display: flex;
    flex-direction: column;
    ${typography['body1regular']};
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobile}) {
      color: ${({ theme }) => theme.whiteColor};
    }

    .link, a {
      text-decoration: underline;
      font-weight: 700;
    }
  }
`;
